/* eslint-disable @typescript-eslint/no-this-alias */
import React from 'react';
import axios from 'axios';
import Text from '../../inputs/Text.jsx';
import { Box, CircularProgress, Grid, TextField, Typography } from '@mui/material';
import AutocompleteBaseInput from '../../../common/inputs/AutocompleteBaseInput.jsx';
import CardClient from '../../../common/cards/CardClient.jsx';
import { uniqueId } from '../../../../../utils.js';
import Button from '../../buttons/Button.jsx';
import CardClientProfile from '../../../providers/common/cards/CardClientProfile';
import i18n from 'i18next'; 

let cancelToken;

export default class RequestSiteClientsSelector extends React.Component {

    constructor(props) {
        super(props);
        
        this.inputRef = null;
        this.search_timeout = null;

        this.initial_state = {
            loading: false,
            open: false,
            client: '',
            clients: [],
            manager: '',
            selectedClient: {},
            finalClientEmail: '',
            finalClientId: this.props.final_client_id,
            source: this.props.source,
       
        }

        this.state = {
            ...this.initial_state,
        };

        this.inputStyles = {
            input: {
                color: '#F0672F',
                fontSize: '1.25em',
                letterSpacing: '-0.1px',
                fontWeight: 'bold'
            },
            "& .MuiAutocomplete-input": {
                paddingTop: '.7rem !important',
                paddingBottom: '.7rem !important'
            },
            "& .MuiFilledInput-root": {
                borderRadius: '0.38rem',
            }
        }

        document.addEventListener('js-nav-close', this.resetState);
    }

    componentDidMount() {

        if(this.state.finalClientId != ''){
            this.getClientProfile();
        }
    }

    componentWillUnmount() {
        this.removeEventListener();
        if (this.search_timeout) clearTimeout(this.search_timeout);
    }

    getClientProfile = async e => {
        try {
            const result = await axios.get(
                ENV.base_lang_url + "myspace/" + this.state.source + "//clients/get_profile/" + this.state.finalClientId
            )
            this.setState({
                client: result.data.customer,
                manager: result.data.manager
            });

        } catch (error) {

        }
    }

    removeEventListener() {
        document.removeEventListener('js-nav-close', this.resetState);
    }

    getSearchClientsParams = (query) => {
        if (typeof cancelToken != typeof undefined) {
            cancelToken.cancel("Operation canceled due to new request.")
        }
        cancelToken = axios.CancelToken.source()
        return {
            url: ENV.base_lang_url + "myspace/providers//ajaxGetter/search_clients",
            params: { 
                headers: {'Content-Type': 'multipart/form-data'},
                cancelToken: cancelToken.token
            },
            data: { q: query }
        }
    }

    handleChangeEmail = (value) => {
        this.setState({finalClientEmail: value});
    }

    handleSearch = (e, value, reason) => {
        if (reason !== 'reset') {
            this.setState({ 
                clients: [],
            });
    
            if (this.search_timeout) clearTimeout(this.search_timeout);
    
            this.search_timeout = setTimeout(() => {
                this.searchClients(value); 
            }, 350);
        }
    };

    handleChange = (e,value) => {

        if (value) {

            if (!(!!value.id)) {

                let link_add = (this.props.context ?? 'classic') == 'resa' 
                ? 'providers//clients/form_new_final_client_resa/' + this.props.requests_id + '/' + this.props.requests_hotels_id
                :'providers//clients/form_new_final_client/' + this.props.requests_id + (this.props.requests_hotels_id ? '/' + this.props.requests_hotels_id : '');

                GLOBAL_NAV.go(nav.get_part('self','-', link_add));
            }
        }

        this.setState({
            selectedClient: value,
            open: false
        });
    }

    searchClients = (q) => {
        const { selectedClient,
             } = this.state;
        if (q.length) {
            if (!Object.keys(selectedClient ?? {}).length || q !== selectedClient.label) {
                this.setState({
                    loading: true,
                    open: true
                });
            }
        } else {
            this.setState({
                loading: false,
                open: false
            });
        }

        const { url, data, params } = this.getSearchClientsParams(q);
        axios.post(url, data, params) 
        .then(response => {
            const clients = response.data;
            this.setState({ 
                loading: false,
                clients
            });
            if (this.search_timeout) clearTimeout(this.search_timeout);
        });
    }

    resetState = (e) => {
            this.setState({ ...this.initial_state });
    }

    getOptionLabel= (client) => {
        let label = '';
        if (typeof client === 'object' &&  Object.keys(client).length) {
            label = client.label;
        }
        return label;
    }

    handleSubmit = () => {
        nav.wait(true);
        if(this.state.source == 'providers'){
            axios.post(
                ENV.base_lang_url + "myspace/" + this.state.source + "//requests/final_client_save",
                {
                    requests_id: this.props.requests_id,
                    requests_hotels_id: this.props.requests_hotels_id ?? null,
                    final_client_id: this.state.selectedClient.id,
                    context: this.props.context ?? 'classic',
                }, 
                {headers: {'Content-Type': 'multipart/form-data'}}
            )
            .then(response => {
                nav.wait(false);
                nav.infos(response.data.msg)
                
                if ( !this.props.requests_hotels_id ) {
                    GLOBAL_NAV.go(nav.get_part('self', '-'));
                }
                else if(response.data.context == 'resa'){
                    GLOBAL_NAV.go(nav.get_part('self', 2, this.state.source + '//requests_hotels/confirm_reservation/' + this.props.requests_hotels_id));
                }else{
                    GLOBAL_NAV.go(nav.get_part('self', 2, this.state.source + '//requests_hotels/edit_payment_informations/' + this.props.requests_hotels_id));
                    // GLOBAL_NAV.close($('section[data-tag="' + this.state.source + '-requests-final_client"]'), true);
                }
            })
            .catch(error => {
                // nav.infos('error')
                // this.setState({
                //     error
                // });
            });
        }
    }

    handleSubmitClients = async (e, value) => {
        nav.wait(true);
        e.preventDefault();
        if(this.state.source == 'clients'){
            this.setState({btnIsLoading: true});

            axios.post(
                ENV.base_lang_url + "myspace/" + this.state.source + "//requests/final_client_save",
                {
                    requests_id: this.props.requests_id,
                    requests_hotels_id: this.props.requests_hotels_id ?? null,
                    final_client_email: this.state.finalClientEmail,
                    context: this.props.context ?? 'classic',
                }, 
                {headers: {'Content-Type': 'multipart/form-data'}}
            )
            .then(response => {
                nav.wait(false);
                if(response.data.clientExist){
                    this.setState({btnIsLoading: false});
                    nav.infos(response.data.msg)

                    if(response.data.context == 'resa'){
                        GLOBAL_NAV.go(nav.get_part('self', '-', this.state.source + '//requests_hotels/confirm_reservation/' + this.props.requests_hotels_id));
                    }else{
                        GLOBAL_NAV.go(nav.get_part('self', 2, this.state.source + '//requests_hotels/edit_payment_informations/' + this.props.requests_hotels_id));
                        // GLOBAL_NAV.close($('section[data-tag="' + this.state.source + '-requests-final_client"]'), true);
                    }
                    
                }else{
                    if(response.data.context == 'resa'){
                        GLOBAL_NAV.go(nav.get_part('self', '-', this.state.source + '//clients/form_new_final_client_resa/' + this.props.requests_id + '/' + this.props.requests_hotels_id + '/' + this.state.finalClientEmail));
                    }else{
                        GLOBAL_NAV.go(nav.get_part('self', '-', this.state.source + '//clients/form_new_final_client/' + this.props.requests_id + '/' + this.props.requests_hotels_id + '/' + this.state.finalClientEmail));
                    }
                }
            })
            .catch(error => {
            });
        }
    }

    handleRemove = async () => {
        nav.wait(true);
        axios.post(
            ENV.base_lang_url + "myspace/" + this.state.source + "//requests/final_client_remove",
            {
                requests_id: this.props.requests_id,
                requests_hotels_id: this.props.requests_hotels_id ?? null
            }, 
            {headers: {'Content-Type': 'multipart/form-data'}}
        )
        .then(response => {
            nav.wait(false);
            nav.infos(response.data.msg)
            GLOBAL_NAV.close($('section[data-tag="' + this.state.source + '-requests-final_client"]'), true);
            GLOBAL_NAV.reload();
        })
        .catch(error => {
            // nav.infos('error')
            // this.setState({
            //     error
            // });
        });
    }

    render() {
        const { 
            open,
            client,
            loading,
            clients,
            manager,
            source,
            finalClientId,
            selectedClient,
            finalClientEmail,
        } = this.state;

        let required_attributes = {};
        if (this.props.required) {
            required_attributes['data-parsley-validate-if-empty'] = true;
            required_attributes['data-parsley-type'] = 'email';
            required_attributes['data-parsley-error-message'] = this.props.trad.required_error_message;
        }


        const clientProfile = {
            ...client,
            firstName: client.surname,
            lastName: client.name,
            fonction: client.function,
            emailHasError: client.email_has_error,
            accountInstance: {
                sendEmail: client.send_email
            }
        }
        
        return (
            <>
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h3 className="font-weight-bold m-0">
                        {'final_client'.trad()}
                    </h3>   

                    {finalClientId && <div>
                        <Button
                            onClickFunction={() => this.setState({finalClientId: ''})}
                            text={'edit'.trad()} 
                            color={'light-blue-dark'}
                            icon={'fa-regular fa-pen-to-square'}
                        />

                        <span className="ml-2">
                            <Button
                                onClickFunction={() => this.handleRemove()}
                                text={'remove'.trad()} 
                                color={'light-blue-dark'}
                                icon={'fa-regular fa-trash'}
                            />
                        </span>
                    </div>}

                </div>

                <div>
                    <p className="font-weight-normal m-0 mb-4">
                        {'final_client_card_text'.trad()}
                    </p>
                </div>

                {
                    finalClientId ?

                        <div className="row">
                            <div className="col-12">
                                <div className="border border-light rounded">
                                    {client && <CardClientProfile
                                        client={clientProfile}
                                        manager={manager}
                                        showBtnEdit={false}
                                        showBtnTask={false}
                                        showKpis={false}
                                    />}                                   
                                </div>
                            </div>
                        </div>

                    :

                    source === 'clients' ?
                    <div className="row">
                        <div className="col-12">
                            <form 
                                onSubmit={this.handleSubmitClients}
                            >
                                <div className="mb-3">
                                    <Text
                                        label={'indiquer_ladresse_mail_du_client_final'.trad()} 
                                        slug={'email'}
                                        value={finalClientEmail} 
                                        onChange={(value) => this.handleChangeEmail(value)}
                                    />      
                                </div>
                                <Button
                                    text={'next'.trad()} 
                                    color={'orange'} 
                                    size={'large'}
                                    width={'100'}
                                    type={'submit'}
                                    isLoading={loading}
                                />  
                            </form>    
                        </div>
                    </div>

                    :

                    <>

                    <AutocompleteBaseInput
                        freeSolo={true}
                        getOptionLabel={(client) => this.getOptionLabel(client)}
                        filterOptions={(x) => x}
                        options={clients}
                        variant={'filled'}
                        autoComplete={true}
                        autoHighlight={true}
                        includeInputInList={true}
                        filterSelectedOptions={true}
                        value={selectedClient}
                        onChange={this.handleChange}
                        onInputChange={this.handleSearch}
                        loading={loading}
                        open={open}
                        ListboxProps={{
                            style: {
                                padding: 0
                            }
                        }}
                        renderInput={(params) => (
                            <TextField 
                                {...params} 
                                hiddenLabel
                                fullWidth 
                                variant="filled" 
                                placeholder={i18n.t('Rechercher un client par nom, prénom ou email')}
                                autoFocus
                                sx={this.inputStyles}
                                inputRef={(input) => this.inputRef = input}
                                InputProps={{
                                    ...params.InputProps,
                                    disableUnderline: true,
                                    endAdornment: (
                                        <React.Fragment>
                                            {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                            {params.InputProps.endAdornment}
                                        </React.Fragment>
                                    ),
                                    onKeyDown: (e) => {
                                        if (loading) e.stopPropagation();
                                    }
                                }}
                            />
                        )}
                        renderOption={(props, client) => {
                            return (
                            <li {...props} key={uniqueId()} style={{ minHeight: '3rem' }}>
                                <Grid container alignItems="center">
                                    <Grid item>
                                        <Box component="span" sx={!(!!client.id) ? { fontWeight: 'bold', color: '#F0672F', 'background': '' } : { fontWeight: 'bold' }}>
                                            {client.label}
                                        </Box>

                                        { !!client.id && (
                                            <Typography variant="body2" color="text.secondary">
                                                { client.email && (
                                                    <Box component="span" className="d-inline-flex align-items-center mr-2">
                                                        <i className='fa-regular fa-envelope mr-1'></i>
                                                        {client.email}
                                                    </Box>
                                                )}
                                                { client.phone && (
                                                    <Box component="span" className="d-inline-flex align-items-center">
                                                        <i className="fa-regular fa-phone mr-1"></i>
                                                        {client.phone}
                                                    </Box>
                                                )}
                                            </Typography>
                                        )}
                                    </Grid>
                                </Grid>
                            </li>
                            );
                        }}

                    />

                    {
                        selectedClient && !!selectedClient.id  && (

                            <>
                                <div className="col-12 px-0 mt-3">
                                    <CardClient
                                        client={selectedClient} 
                                        details={true} 
                                        backgroundColor={'light'} 
                                    />

                        
                                </div>

                                <Button
                                        className='mt-4'
                                        text={'save'.trad()} 
                                        color={'orange'} 
                                        size={'large'}
                                        width={'100'}
                                        type={'submit'}
                                        isLoading={loading}
                                        onClickFunction={this.handleSubmit}
                                />

                            </>
                        )
                    }

                    <div className="col-12">
                        <div className="h3 font-weight-normal text-center m-0 my-5">
                            {'or'.trad()}
                        </div>                
                    </div>
                        
                    <div className="col-12">
                        <Button
                            id="btn_form"
                            text={'add_client'.trad()} 
                            color={'light-blue-dark'} 
                            size={'large'}
                            width={'100'}
                            type={'link'}
                            href={
                                (this.props.context ?? 'classic') == 'resa' ? 
                                'providers//clients/form_new_final_client_resa/' + this.props.requests_id + '/' + this.props.requests_hotels_id
                                :
                                'providers//clients/form_new_final_client/' + this.props.requests_id + (this.props.requests_hotels_id ? '/' + this.props.requests_hotels_id : '')
                            }
                            part='-1'
                        />             
                    </div>                  

                    </>

                }

            </>
        );
    }
}